import React from 'react';

import { locale } from '@trqk/utils';

import dragDropIconsImg from './images/tip_dragdrop_tracks@2x.png';

export const CallToAction = (): JSX.Element => (
    <div className="ml-6 text-xs font-semibold relative">
        <div className="relative">
            <img
                className="absolute"
                style={{
                    top: -30,
                    left: -30,
                }}
                src={dragDropIconsImg}
                alt="Example of dragging an audio file"
                width={157}
                height={98}
            />
        </div>
        <div className="pl-32 py-3 pr-3 bg-primary-100 rounded-lg flex justify-between">
            <div className="flex-grow ">{locale.enUS.AUDIO_UPLOAD_CTA}</div>
        </div>
    </div>
);
